<template>
  <section
    class="card"
    :class="[state && state.matches('editing') ? 'editing' : '']"
  >
    <translate tag="h3" class="section-heading personal-details">
      Personal details
    </translate>

    <personal-details-form
      v-if="state && (state.matches('editing') || state.matches('submitting'))"
      :personal-details="editablePersonalDetails"
      :server-errors="errors"
      @submit="submitPersonalDetails"
      @cancel="cancelEditingPersonalDetails"
      @change="detailsChanged"
    />

    <personal-details-show
      v-else-if="state && state.matches('idle')"
      :personal-details="personalDetails"
      @edit-details="editPersonalDetails"
    />
    <loading-spinner v-else-if="state && state.matches('fetching')" />
  </section>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import {
  UserPersonalDetailsMachineInterpreter,
  returnUserPersonalDetailsMachine,
} from '../machines/machine'
import { interpret } from 'xstate-v4'

@Component
class PersonalDetails extends Vue {
  machine: UserPersonalDetailsMachineInterpreter | null = null
  state: UserPersonalDetailsMachineInterpreter['state'] | null = null

  mounted() {
    this.startMachine()
  }

  submitPersonalDetails() {
    this.machine?.send('SUBMIT_PERSONAL_DETAILS')
  }

  detailsChanged(event: Record<string, string>) {
    this.machine?.send('MODIFY_EDITABLE_PERSONAL_DETAILS', {
      personalDetailsEdited: { ...event },
    })
  }

  editPersonalDetails() {
    this.machine?.send('EDIT_PERSONAL_DETAILS')
    this.$puScrollTo('.personal-details', {
      duration: 200,
      offset: -25,
    })
  }

  cancelEditingPersonalDetails() {
    this.machine?.send('CANCEL_EDITING_PERSONAL_DETAILS')
  }

  get errors() {
    return this.state?.context.errors
  }

  get editablePersonalDetails() {
    return this.state?.context.personalDetailsEditing
  }

  get personalDetails() {
    return this.state?.context.personalDetails
  }

  private startMachine() {
    const machine = returnUserPersonalDetailsMachine()
    this.machine = interpret(machine)
      .onTransition((state) => {
        if (state.changed) {
          this.state = state
        }
      })
      .start()
  }
}

export default toNative(PersonalDetails)
</script>
<style scoped>
.card.editing {
  position: relative;
  z-index: 1;
}

.card.editing:before {
  background: rgba(0, 0, 0, 0.5);
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  bottom: 0;
  right: 0;
  pointer-events: all;
}

.card.editing:after {
  background: white;
  content: '';
  width: 100%;
  height: 100%;
  z-index: -1;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: var(--border-radius);
}
</style>
